import { PageContainer } from "@ant-design/pro-components";
import { Link, useParams } from "react-router-dom";
import { useState } from "react";
import Permissions from "./permissions";
import { findOrgPermiss, findOrgAllPermiss } from "@api";
import { BasicTable, HView } from "@/components";
import { useTranslation } from "react-i18next";
import { TABLEPAI, PageEnum, USER_MANAG, ORGANIZ } from "@/enums/pageEnum";

export default function TypeDetailPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const ORGANIZATION = "organization";
  const [tabActiveKey, setTabActiveKey] = useState<string>(ORGANIZATION);
  const [defaMenus, setDefaMenus] = useState<string[] | undefined>();
  const [userMenus, setUserMenus] = useState<string[] | undefined>();
  const columns = [
    { title: t("organization"), dataIndex: "name" },
    {
      title: t("action"),
      dataIndex: "action",
      renderText: (_: string, record: { id: string }) => {
        return (
          <HView
            name={t("view")}
            path={`${PageEnum.USERMANGMENTDETAL}/${record?.id}`}
            state={record}
          />
        );
      },
    },
  ];
  const removePeriss = (item: string) =>
    item !== USER_MANAG && item !== ORGANIZ;

  return (
    <div className="bg-[#f2f2f2] dark:bg-[#000] typeDetailCalss">
      <PageContainer
        tabList={[
          { tab: t("organization"), key: ORGANIZATION },
          { tab: t("permissions"), key: "permissions" },
        ]}
        tabActiveKey={tabActiveKey}
        onTabChange={async (key) => {
          setTabActiveKey(key);
          if (key !== ORGANIZATION) {
            const userPers = await findOrgPermiss(id);
            const allPerms = await findOrgAllPermiss();
            const delUserPers = userPers.data.body?.filter(removePeriss) || [];
            const cuPers = allPerms.data.body?.filter(removePeriss) || [];
            setUserMenus(delUserPers.sort());
            setDefaMenus(cuPers.sort());
          } else {
            setUserMenus([]);
            setDefaMenus([]);
          }
        }}
        header={{
          title: <span className="text-[20px] font-medium">{t(id || "")}</span>,
          breadcrumb: {
            items: [
              {
                title: (
                  <Link to={PageEnum.ORGANIZATION}>{t("organization")}</Link>
                ),
              },
              {
                title: (
                  <Link to={PageEnum.TYPESETTING}>{t("typeSetting")}</Link>
                ),
              },
              { title: t("detail") },
            ],
          },
        }}
      >
        {tabActiveKey === ORGANIZATION ? (
          <BasicTable
            isShowCheckbox={false}
            columns={columns}
            isDefaultToolBar={false}
            className="min-h-[calc(100vh-250px)]"
            requestUrl={`${TABLEPAI.ORGANIZA}?type=${id}`}
          />
        ) : (
          <Permissions
            allPermissions={defaMenus}
            userPermission={userMenus}
            type={id}
            apiUrl={TABLEPAI.ORGAPERMISS}
          />
        )}
      </PageContainer>
    </div>
  );
}
